import { render, staticRenderFns } from "./BindTags.vue?vue&type=template&id=74e86f48&scoped=true&"
import script from "./BindTags.vue?vue&type=script&lang=js&"
export * from "./BindTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e86f48",
  null
  
)

export default component.exports